import Vue from 'vue';
import { wordEnding } from '@shared/lib';
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import TouristGroupView from '@/js/common/components/touristGroupView/TouristGroupView';
import { TouristGroupSelector } from '@features/searchCriteria/selectTouristGroup';
import getStore from '@ve/services/getStore/getStore';
import { NAMESPACE_TOURIST_GROUP } from '@entities/searchCriteria/touristGroup';
import TouristGroupFactory from '@/js/common/Domain/Factory/TouristGroup';

import dropDownTemplate from './templates/dropDownTemplate.html';
import './styles/touristGroupView.scss';

@propsDecorator({
    template: dropDownTemplate,
    computeds: {
        labelText: {
            deps: ['isGroupSearch', 'model'],
            get(isGroupSearch, model) {
                if (!isGroupSearch) return 'Туристы';
                const roomsCount = model ? model.get('touristsByRooms').length + 1 : 1;
                    
                return `${roomsCount} ${wordEnding(roomsCount, 'номер;номера;номеров')} для`;
            },
        }
    }
})

export default class TouristGroupDesktop extends TouristGroupView {
    initSpinner() {
        this.fromField
            .spinner({
                min: 1,
                max: 6,
                icons: { down: 'ui-icon-minus', up: 'ui-icon-plus' },
            })
            .on('spinstop', this.controlChanged.bind(this)) // основной обработчик изменения кол-ва взрослых
            .on('change', this.updateButton);
    }

    updateButtons() {
        this.updateButton.call(this.fromField);
    }

    toggleDropdown() {
        if (!this.$el.hasClass('disable')) {
            this.dataLayerAnalyticsEvent();
            this.$el.toggleClass('open');
            this.touristGroupDropdown?.$refs.dropDownRef.toggle();
        }
    }

    updateButton(event, params) {
        const value = params && params.value ? params.value : $(this).val();
        const min = $(this).spinner('option', 'min');
        const max = $(this).spinner('option', 'max');
        const $decreaseButton = $(this).parent().find('.ui-spinner-down');
        const $increaseButton = $(this).parent().find('.ui-spinner-up');
        if (value <= min) {
            $decreaseButton.addClass('ui-state-disabled');
        } else {
            $decreaseButton.removeClass('ui-state-disabled');
        }

        if (value >= max) {
            $increaseButton.addClass('ui-state-disabled');
        } else {
            $increaseButton.removeClass('ui-state-disabled');
        }
    }

    initViewModelEvents() {
        this.viewModel.on('change:variants', (e) => {
            if(this.model.get('model')) {
                this.setValue(this.model.get('model'));
            }
        }); 
    }

    getAdults() {
        return parseInt(this.fromField.spinner('value'), 10) || this.model?.get('model')?.get('adults');
    }

    setValue(model) {
        const { adults, kids, infants, touristsByRooms } = model.toJSON();
        this.setLabel({
            adults: adults,
            kids: kids,
            infants: infants,
            touristsByRooms,
            isGroupSearch: this.viewModel.get('isGroupSearch'),
            variants: this.viewModel.get('variants'),
        });
    }

    modelChanged(event, model, context) {
        if (context?.initiator !== 'view') {
            if (model === null) {
                this.$el.addClass('disable');
            } else {
                this.$el.removeClass('disable');
                this.updateChildesList(model);
                this.setValue(model);
            }
        }

        if (model !== null) {
            this.fromField.spinner('value', model.get('adults'));
            this.updateButtons();
        }
    }

    initDOMVariables() {
        this.fromField = $('.tour-adults', this.$el);
        this.$inputText = $('.formInputPlace', this.$el);
    }

    initDomEvents() {
        this.$el.addClass('disable');
        $('> .formInput', this.$el).on('click', this.toggleDropdown.bind(this));
        $(document).on('click', (event) => {
            const $dropdowns = this.$el.filter('.open');
            const $clickedDropdown = $(event.target);
            const $clickedContainer = $clickedDropdown.parents('.formDropdown');
            const $hideDropdowns = $dropdowns.not($clickedContainer).not($clickedDropdown);

            $hideDropdowns.removeClass('open');

            if (!$clickedDropdown.parents('.formDropdown.touristGroup').length) {
                this.touristGroupDropdown?.$refs.dropDownRef.close();
            }
        });

        this.$el.addClass('disable');
    }

    render() {
        this.$el.html(this.template({ cid: this.cid, isGroupSearch: this.isGroupSearch }));
    }

    initVuexStoreEvent() {
        const store = getStore();
        const nameSpace = `${NAMESPACE_TOURIST_GROUP}${this.modelPrefix}`;

        store.watch(
            (state, getters) => getters[`${nameSpace}/touristGroup`],
            (touristGroup) => {
                if (!this.model.get('model')) return;

                this.model.set('model', TouristGroupFactory(touristGroup), { modifiedByStore: true });
            }
        );
    }

    initTouristGroupDropdown() {
        const store = getStore();
        const vueAnchor = this.$el.parents().find('.js-tourist-group-dropdown')[0];

        [this.touristGroupDropdown] = new Vue({
            name: 'TouristGroupSelector',
            render: (h) => h(TouristGroupSelector, {
                props: {
                    modelPrefix: this.modelPrefix,
                },
            }),
            store,
        }).$mount(vueAnchor).$children;
    }

    initPortalElement() {
        const modalElement = document.getElementsByClassName('vue-portal-target')[0];

        if (!modalElement) {
            const elementForMounting = document.createElement('div');
            elementForMounting.className = 'js-portal-target';
            document.getElementsByTagName('body')[0].appendChild(elementForMounting);

            new Vue({
                template: '<portal-target name="dropdown-target"></portal-target>',
            }).$mount('.js-portal-target');
        }
    }

    // viewModelDecorator плохо работает с наследованием и super, поэтому isGroupSearch сохранять в две переменные: для метода render, и для computed
    initialize(options = {}) {
        const isGroupSearchAllowed =
            !['serp_hotel', 'serp_railway'].includes(options.searchFormSearchType) || !!options.isGroupSearchAllowed;
        this.isGroupSearch = isGroupSearchAllowed;
        this.modelPrefix = options.modelPrefix || '';
        this.$openLink = $(options.openLink);
        super.initialize(options);
        this.initSpinner();
        this.viewModel.set('isGroupSearch', isGroupSearchAllowed); 
        if (this.viewModel.get('isGroupSearch')) {
            this.initPortalElement();
            this.initTouristGroupDropdown(options);
            this.initVuexStoreEvent();
        }
        this.initViewModelEvents();
    }
}